module.exports = __webpack_public_path__ + "img/top-model.a9489ec6.png";